import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { SidebarLinkButtonProps } from './types';

import * as S from './styled';

const SidebarLinkButton = ({ isActive, title }: SidebarLinkButtonProps) => {
    const { t } = useTranslation();

    return (
        <S.NavButton>
            <Text bold={isActive} type="large-text" color="text-main">
                {t(title)}
            </Text>
        </S.NavButton>
    );
};

export default SidebarLinkButton;
